<!-- 专辑管理 -->
<template>
  <div class="program-group-management">
    <cs-form
      label-width="90px"
      form-width="100%"
      :form="form"
      :formData="searchData"
      :form-col="searchFormCol"
      :inline="true"
      class="header-search-box"
    >
      <template slot="search">
        <el-button type="primary" @click="search">查询</el-button>
      </template>
    </cs-form>
    <div class="padding-b-20">
      <el-button type="primary" @click="goAddGroup">
        <i class="icon-tianjia"></i>
        添加专辑
      </el-button>
    </div>
    <cs-table
      ref="singleTable"
      :tableCols="tableCols"
      :tableData="tableData"
      :paginationOption="paginationOption"
      :show-header="false"
      class="no-shadow-table"
      @size-change="sizeChangeHandler"
      @current-change="currentPageHandler"
      @selection-change="selectionChange"
      :show-overflow-tooltip="false"
    >
      <template slot-scope="scope" slot="imgUrl">
         <program-list type="1" project="cp" :data="scope.row">
           <el-tag class="publish-state" slot="state-slot" :type="scope.row.pushState==0 ? 'info' : 'success'">{{scope.row.pushState==0?'未发布':'已发布'}}</el-tag>
          <tags-list :data="scope.row.tagsList" slot="title-slot"/>
          <!--<div slot="audit-slot" class="auditStyle">
             <span>审核状态： <span :class="scope.row.auditState|auditStyle">{{scope.row.auditState|auditState}}</span> </span>
          </div>-->
        </program-list>
      </template>
    </cs-table>
    <insideDialog ref="insideDataDialog" :insideData="insideData" :imgUrl="imgUrl" :goEdit="true" @goEditPage="goEdit"/>
    <!-- 数据趋势图 -->
    <DoubleLineDialog ref="DoubleLineDialog" :dialogData='dialogData' :programs="true"/>
    <programsReleaseStatusDialog ref="releaseStatusDataDialog" :id="releaseStatusId"></programsReleaseStatusDialog>
  </div>
</template>
<script>
import { addData } from '../../../resource/api/data.js'
import { fetchDictionarys } from '../../../resource/api/index'
import { fetchSetsProgramsPush } from '../../../resource/api/releases'
import { programSets } from '../../../resource/api/program-group-management'
import insideDialog from '@/views/common/dialog/program-group-detail.vue'
import DoubleLineDialog from '@/views/common/dialog/program-group-doubleLine.vue'// 播放统计dialog
import ProgramList from '@/components/ProgramList'
import TagsList from '@/components/TagsList'
import programsReleaseStatusDialog from '@/views/common/dialog/programsReleaseStatusDialog.vue'

export default {
  components: {
    ProgramList,
    TagsList,
    insideDialog,
    programsReleaseStatusDialog,
    DoubleLineDialog
  },
  data () {
    return {
      dialogData: '',
      imgUrl: '',
      passStyle: '',
      categoryList: [],
      auditOptions: [],
      releaseStatusId: '',
      releaseStatusData: [],
      form: {
        name: '',
        category: '',
        auditState: '',
        operator: '',
        limit: 10,
        offset: 1
      },
      searchFormCol: {
        gutter: 10,
        sm: 12,
        md: 8,
        lg: 6
      },
      tableCols: [
        {
          prop: 'imgUrl',
          label: '封面图',
          type: 'slot',
          align: 'left'
        },
        {
          prop: 'control',
          type: 'spbtn',
          label: '操作',
          width: 200,
          groups: [
            {
              isShow: () => true,
              title: '详情',
              clickHandler: this.goInsideDetailInfo
            },
            {
              isShow: () => true,
              title: '管理',
              clickHandler: this.goManagementGroup
            },
            {
              isShow: (row) => { return row.pushState == 0 && row.pushFlag },
              title: '发布',
              clickHandler: this.goPushFlag
            },
            {
              isShow: (row) => { return row.pushState != 0 },
              title: '发布状态',
              clickHandler: this.goPushFlagState
            }
          ]
        }
      ],
      tableData: [],
      multipleSelection: [],
      paginationOption: {},
      insideData: {},
      detailData: {},
      groupIn: 'programs',
      paginationReleaseOption: {},
      releaseFrom: {
        id: '',
        limit: 20,
        offset: 1
      }
    }
  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '标题：',
          placeholder: '请输入',
          clearable: true,
          labelWidth: '60px',
          col: [3, 3, 3]
        },
        {
          prop: 'category',
          label: '分类：',
          type: 'select',
          filterable: true,
          clearable: true,
          options: this.categoryList
        },
        {
          prop: 'pushState',
          label: '发布状态：',
          type: 'select',
          filterable: true,
          clearable: true,
          options: [{
            label: '全部',
            value: ''
          }, {
            label: '未发布',
            value: '0'
          }, {
            label: '已发布',
            value: '1'
          }]
        },
        {
          prop: 'search',
          type: 'slot',
          label: '',
          col: [3, 3, 3]
        }
      ]
    }
  },
  created () {
    this.pageInit()
    this.auditOptions = addData.auditOptions
  },
  methods: {
    // 初始化
    pageInit () {
      this.form.operator = this.$store.state.router.createBy
      this.paginationOption['page-size'] = this.$store.state.pageLimit
      this.form.limit = this.$store.state.pageLimit
      this.getData(this.form)
      this.getCategoryList()
    },
    // 加载数据
    getData (data) {
      const that = this
      programSets(data).then((res) => {
        if (res.code == 1) {
          that.tableData = res.results.map(item => {
            var itemTagList = []
            itemTagList.push(item.category, item.sndCategory)
            item.tagsList = itemTagList
            return item
          })
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.form.offset,
            total: parseInt(res.total)
          }
        } else {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
      })
    },
    // 查询
    search (val) {
      this.form = {
        ...this.form,
        offset: 1,
        limit: this.$store.state.pageLimit
      }
      this.currentPageHandler(1)
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection
    },
    sizeChangeHandler (val) {
      this.form.limit = val
      this.form.offset = 1
      this.getData(this.form)
    },
    currentPageHandler (val) {
      this.form.offset = val
      this.getData(this.form)
    },
    // 去添加节目集
    goAddGroup () {
      this.$router.push({
        path: '/createGroup'
      })
    },
    // 节目编辑
    goManagementGroup (row) {
      this.$router.push({
        name: 'ugcmanagementGroup',
        query: {
          dataParams: JSON.stringify({
            publish: row.pushState != 0,
            programSetId: row.id,
            category: row.category
          })
        }
      })
    },
    // 查看详情
    goInsideDetailInfo (row) {
      this.insideData = row
      this.imgUrl = row.posterH
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.insideDataDialog.open()
      })
    },
    pushFlagShowHide (row) {
      // 节目集查询的未发布是通过pushState查的，pushFlag是判断节目集下是否有节目
      // pushFlag：false 该节目集下没有节目 true 该节目集下有节目  pushState：0 未发布 3已发布
      return row.pushFlag == true && row.pushState == 0
    },
    pushFlagStateShowHide (row) {
      return row.pushState == 3
    },
    // 查看发布状态
    goPushFlagState (row) {
      this.releaseStatusId = row.id
      this.$nextTick(() => {
        this.$refs.releaseStatusDataDialog.open()
      })
    },
    dbClick (row) {
      this.goInsideDetailInfo(row)
    },
    // 点击发布按钮
    goPushFlag (row) {
      this.$confirm('专辑发布后，专辑以及作品都不可修改、解绑，之后新加入的作品会自动发布！请确保专辑和作品信息无误?', '提示', {
        confirmButtonText: '立即发布',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const siteAppId = row.siteAppId || 1 + ''
        const data = {
          id: row.id,
          siteAppIds: [siteAppId],
          updateBy: this.$store.state.router.updateBy
        }
        fetchSetsProgramsPush(data).then((res) => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: '专辑发布成功!'
            })
            this.currentPageHandler(1)
          } else if (res.code == 0) {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
    },
    // 获取分类下拉框内容
    getCategoryList: function () {
      var that = this
      that.categoryList = []
      const data = {
        limit: 25,
        dataKey: 'category',
        dataFlag: 0
      }
      fetchDictionarys(data).then((res) => {
        if (res.code != 1) {
          that.$message({
            message: res.msg,
            type: 'error'
          })
          return false
        }
        var dataItem = res.results
        var len = dataItem.length
        var arr = []
        for (var i = 0; i < len; i++) {
          arr.push({ value: dataItem[i].dataValue, label: dataItem[i].dataValue })
        }
        that.categoryList = arr
      })
    },
    goEdit (id) {
      this.$router.push({
        path: process.env.VUE_APP_NODE_ENV == 'CP' ? '/createGroup' : process.env.VUE_APP_NODE_ENV == 'UGC' ? '/editGroup' : '/programGroupManagement',
        query: {
          programSetId: id.id
        }
      })
    }
  }
}
</script>
